import { Component, OnInit } from '@angular/core';
import { BlogDataService } from '@shared/service/blog-data.service';
import { SingelBlogModel } from '@shared/models/blog.model';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-detail-no-sidebar',
  templateUrl: './detail-no-sidebar.component.html',
  styleUrls: ['./detail-no-sidebar.component.scss']
})
export class DetailNoSidebarComponent implements OnInit {
  blogData: SingelBlogModel;
  postId: string;

  constructor(
    public blogDataService: BlogDataService,
    private route: ActivatedRoute,
  ) {

    this.route.paramMap.subscribe(r => {
      this.postId = r.get('id');
      console.log(this.postId);
      this.blogData = this.blogDataService.selectBlogPostById(this.postId);
    });
  }

  ngOnInit() {
    // if (!this.blogDataService.selectedArticle || this.blogDataService.selectedArticle === undefined || this.blogDataService.selectedArticle === null) {
    //   this.blogDataService.selectedArticle = this.blogDataService.allBlogPressedData.data[0];
    //   this.blogData = this.blogDataService.selectedArticle;
    //   return;
    // }
    // this.blogData = this.blogDataService.selectedArticle;
  }

}
